import { autoUpdate, computePosition, flip, offset, Placement, ReferenceElement, shift } from "@floating-ui/dom";

export type FloatOptions = { placement?: Placement };
export default function float(reference: ReferenceElement, floater: HTMLElement, options: FloatOptions) {
  function updatePosition() {
    computePosition(reference, floater, {
      placement: options.placement || "top",
      middleware: [offset(4), flip(), shift({ padding: 5 })],
    }).then(({ x, y }) => {
      Object.assign(floater.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  }

  updatePosition();
  // returns a cleanup function https://floating-ui.com/docs/autoUpdate
  return autoUpdate(reference, floater, updatePosition);
}
